import Vue from 'vue'
import Vuex from 'vuex'
// BrandDeKonstrucktor
import BrandDeKonstrucktor from './modules/BrandDeKonstruktor/BrandDeKonstruktor';
import BrandDeKonstrucktorMain from './modules/BrandDeKonstruktor/BrandDeKonstrucktorMain';
import BrandDeKonstrucktorSearching from "./modules/BrandDeKonstruktor/DeKonstructorSearching";
import SearchHistory from "./modules/BrandDeKonstruktor/SearchHistory";
import DeKonstruktReport from "./modules/BrandDeKonstruktor/DeKonstruktReport";
import BrandKonstrucktorTrademarkCategory from "./modules/BrandDeKonstruktor/BrandKonstrucktorTrademarkCategory";

// BrandKonstrucktor
import BrandKonstrucktor from './modules/BrandKonstruktor/BrandKonstruktor';
import BrandKonstruktorSearchHistory from "./modules/BrandKonstruktor/BrandKonstruktorSearchHistory";
import BrandKonstruktorKonstruct from "./modules/BrandKonstruktor/BrandKonstruktorKonstruct";
import BrandKonstrucktorWordBank from "./modules/BrandKonstruktor/BrandKonstruktorWordBank"
//user
import UserManagement from "./modules/User/UserManagement";
//contact us
import ContactUs from "./modules/ContactUs/contactUs"

//payment
import Payment from "./modules/Payment/Payment";

//Plan
import Plan from "./modules/Plan/Plan";

// Brand Center
import BrandCentre from "@/store/modules/BrandCentre/BrandCentre";

// Brand Checker
import BrandCreator from "@/store/modules/BrandCreator/BrandCreator";

// Brand Checker
import BrandChecker from "@/store/modules/BrandChecker/BrandChecker";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        //DeKonstruktor
        BrandDeKonstrucktor,
        BrandDeKonstrucktorMain,
        BrandDeKonstrucktorSearching,
        SearchHistory,
        DeKonstruktReport,
        BrandKonstrucktorTrademarkCategory,

        // Konstruktor
        BrandKonstrucktor,
        BrandKonstruktorSearchHistory,
        BrandKonstruktorKonstruct,
        BrandKonstrucktorWordBank,

        // User
        UserManagement,
        //contact Us
        ContactUs,

        //Payment
        Payment,

        //Plan
        Plan,

        //Brand Center
        BrandCentre,

        //Brand Checker
        BrandChecker,

        // Brand Creator
        BrandCreator
    }
})